"use client";
import { useState as n, useEffect as o } from "react";
import { isSafari as r } from "./index39.js";
function s() {
  const [i, t] = n({
    width: 0,
    height: 0
  });
  return o(() => {
    const e = () => {
      setTimeout(() => {
        t({
          width: r() ? document.documentElement.clientWidth : window.innerWidth,
          height: window.innerHeight
        });
      }, 200);
    };
    return e(), window.addEventListener("resize", e), () => window.removeEventListener("resize", e);
  }, []), i;
}
export {
  s as useWindowSize
};
